import { DialogActions } from "@mui/material";
import { draftColors } from "modules/proposals/draft/draftDesignTokens";
import UiButton from "components/base/UiButton";
import { WorksheetLibrarySelection } from "../worksheetFormValues";

export default function MultiSelectFooter({
  selections,
  onSelectMany,
  onClose,
}: {
  selections: WorksheetLibrarySelection[];
  onSelectMany?: (selections: WorksheetLibrarySelection[]) => void;
  onClose: () => void;
}) {
  if (!onSelectMany) {
    return null;
  }

  return (
    <DialogActions
      sx={{
        px: "16px",
        py: "10px",
        borderTop: `1px solid ${draftColors.border}`,
      }}
    >
      <UiButton uiVariant="outlined-small" onClick={onClose}>
        Cancel
      </UiButton>
      <UiButton
        uiVariant="primary-green"
        disabled={selections.length === 0}
        onClick={() => {
          onSelectMany(selections);
          onClose();
        }}
      >
        {selections.length > 0 ? `Add selected (${selections.length})` : "Add selected"}
      </UiButton>
    </DialogActions>
  );
}
